/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Forma della regola di punteggio: dove e su cosa si applica
 */
export enum AmbitoRegolaPunteggio {

    SU_PRATICA = 'SU_PRATICA',

    SINGOLO_ATTRIBUTO_DEI_COMPONENTI = 'SINGOLO_ATTRIBUTO_DEI_COMPONENTI',

    COMPONENTE_AVANZATO = 'COMPONENTE_AVANZATO'
}

